<template>
    <div>
        <phoneNav/>
        <div class="activePage">
            <div class="">
                <div class="activePage-banner">
                    <img src="../../assets/images/web/banner-stars.jpg"/>
                </div>
                <div class="project-cont">
                    <h2>星享汇</h2>
                    <h4>资源共享·学习共进·价值共创</h4>
                    <div class="dec">
                                <span>“星享汇”是由盛大天地牵头成立的、聚焦人工智能、文化创意、软件与信息服务业等产业的科创企业联盟，是盛大天地致力于打造全方位、高效能助推企业发展的科创生态系统的重要组成部分。
                                </span>
                    </div>
                </div>
                <div class="act-cont">
                    <Row>
                        <Col span="24">
                            <div class="act-L">
                                <div class="fPart">
                                    <div class="act-tit">六大功能</div>
                                    <div class="fPart-cont">
                                        <Row>
                                            <Col span="8" v-for="(list, index) in fPart" :key="index">
                                                <div class="fPart-cont-list">
                                                    <div class="stars-icon">
                                                        <img src="../../assets/images/web/icon-stars.png"/>
                                                    </div>
                                                    <div class="f-tit">{{list.fTit}}</div>
                                                    <div class="f-dec">{{list.fDec}}</div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                                <div class="p-serve">
                                    <div class="act-tit">平台服务</div>
                                    <div class="p-serve-list">
                                        <Row>
                                            <Col span="24" v-for="(item, index) in pServe" :key="index">
                                                <div class="p-serve-con">
                                                    <h2><span>·</span>{{item.tit}}</h2>
                                                    <div class="p-serve-box">
                                                        <div class="serve-boxP">
                                                            <div class="pst">{{item.titS1}}</div>
                                                            <div class="pcont">{{item.cont1}}</div>
                                                        </div>
                                                        <div class="serve-boxP">
                                                            <div class="pst">{{item.titS2}}</div>
                                                            <div class="pcont">{{item.cont2}}</div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                                <div class="p-profit">
                                    <div class="act-tit">入会权益</div>
                                    <div class="p-profit-cont">
                                        <div class="p-profit-cont-list" v-for="(pCont, index) in profit" :key="index">
                                            <div class="pcon1">{{pCont.pCont1}}</div>
                                            <div class="pcon2">{{pCont.pCont2}}</div>
                                            <div class="pcon3">{{pCont.pCont3}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </Col>
                        <Col span="24">
                            <div class="act-R">
                                <Affix :offset-top="70">
                                    <AppointmentR
                                            :msg="appointMsg"
                                            :tit="appointTit"
                                            :recordType="2"
                                            :btnTxt="appointBtnTxt"
                                    />
                                </Affix>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
        <FooterPhone/>
    </div>
</template>

<script>
    import AppointmentR from "../../components/AppointmentR";
    import phoneNav from "../../components/phoneNav";
    import FooterPhone from "../../components/FooterPhone";

    export default {
        name: "StarsGather",
        components: {
            AppointmentR,
            phoneNav,
            FooterPhone,

        },
        data() {
            return {
                projectTit: '星享汇',
                subHeading: '资源共享·学习共进·价值共创',
                projectDec: '       “星享汇”是由盛大天地牵头成立的、聚焦人工智能、文化创意、软件与信息服务业等产业的科创企业联盟，是盛大天地致力于打造全方位、高效能助推企业发展的科创生态系统的重要组成部分。',

                fPart: [
                    {
                        fTit: '政企联动',
                        fDec: '星享汇将做好政府与企业沟通的桥梁，帮助企业对接政府资源，协助规范企业经营模式和发展理念，推动产业政策的落实。',
                    },
                    {
                        fTit: '跨界整合',
                        fDec: '星享汇将把不同行业和领域的专家、企业家汇聚起来，推动互动交流，激发创新灵感，整合产业资源，价值共创，推进合作。',
                    },
                    {
                        fTit: '垂直协同',
                        fDec: '星享汇为成员单位提供上下游产业对接、专业领域的垂直分工、投融资等服务。',
                    },
                    {
                        fTit: '内部整合',
                        fDec: '星享汇为成员内部交易、投资和项目合作提供舞台和运行保障机制。',
                    },
                    {
                        fTit: '资源引入',
                        fDec: '星享汇为成员引入政策、法律、金融、财务、社会中介、人力资源等外部资源和服务。',
                    }, {
                        fTit: '宣传推广',
                        fDec: '星享汇将整合成员的宣传渠道和媒体资源，发挥协同营销优势，扩大联盟和成员品牌的影响力。',
                    },

                ],
                pServe: [
                    {
                        tit: '投融资服务',
                        titS1: '融资服务：',
                        cont1: '创业贷款、科技贷、履约贷',
                        titS2: '挂牌上市服务：',
                        cont2: '科创板、双创板、海外挂牌',
                    },
                    {
                        tit: '政策申报服务',
                        titS1: '政府补贴类：',
                        cont1: '上海市中小企业创新资金、上海市文创办专项资金、上海市服务业专项资金、上海市科经委各项政策',
                        titS2: '荣誉资质类:',
                        cont2: '双软评估、高新企业认定、高新技术转化、专精特新、小巨人'
                    },
                    {
                        tit: '人力资源服务',
                        titS1: '人事服务：',
                        cont1: '猎头服务、校园招聘、技术人员外包、员工背调、合伙人机制设计',
                        titS2: '人才服务：',
                        cont2: '科技人员落户、企业高管落户'
                    },
                    {
                        tit: '知识产权服务',
                        titS1: '申请服务：',
                        cont1: '发明专利、实用新型专利、外观设计专利、商标、软件著作权、作品著作权',
                        titS2: '其他服务：',
                        cont2: '知识产权贯标、ISO9001、AAA等级信用证书、知识产权托管服务'
                    }
                ],
                profit: [
                    {
                        pCont1: '权益一',
                        pCont2: '荣誉权',
                        pCont3: '颁发“星享汇理事会理事单位”证书',
                    },
                    {
                        pCont1: '权益二',
                        pCont2: '参评奖励',
                        pCont3: '星享汇价值榜或者年度颁奖。',
                    },
                    {
                        pCont1: '权益三',
                        pCont2: '价值交互',
                        pCont3: '整合知名投资人、行业资深专家等顶级资源的独享私董会，汇聚拥有共同背景、同发展阶段或同工作经历等的专项私董会，尽享高质量社交。',
                    },
                    {
                        pCont1: '权益四',
                        pCont2: '专有分享',
                        pCont3: '分享沙龙、论坛峰会主题分享、星享汇夜宴。',
                    },
                    {
                        pCont1: '权益五',
                        pCont2: '品牌推广',
                        pCont3: '盛大天地运营网站、服务号星享汇版块中人物专访、企业资讯等，并推送产业内网媒以及传统媒体的人物专访',
                    },
                ],
                appointMsg: '填写您的信息，与我们享受青春。',
                appointTit: '申请入会',
                appointBtnTxt:"立即申请",
            }
        },
    }
</script>

<style lang="less">
    .activePage {
        background-color: #fff;
        padding:60px 20px;

        .activePage-banner {
            margin-top:0;
            img {
                border-radius: 10px;
                width:100%;
            }
        }
        .project-cont {
            h2{
                font-size:24px;
                padding-top:20px;
                padding-bottom:5px;
            }
            h4{
                font-size:16px;
                margin-bottom:10px;
                font-weight:normal;
            }
            .dec{
                font-size:12px;
                color:#565D69;
                margin-bottom:30px;
            }
        }
        .act-cont {
            margin-top: 20px;

            .act-L {

                .act-tit {
                    font-size: 18px;
                    color: #000;
                    font-weight: bold;
                    margin-bottom:10px;
                }

                .fPart {
                    margin-bottom: 20px;

                    .fPart-cont {
                        text-align: center;

                        .ivu-row {
                            margin: 0 -10px;

                            .fPart-cont-list {
                                margin: 0 10px 30px 10px;
                                color: #333;
                                transition: all 0.3s;
                                .f-tit {
                                    font-size: 16px;
                                    margin: 10px 0 5px 0;
                                }

                                .f-dec {
                                    color: #666;
                                    text-align: left;
                                }
                            }
                        }
                    }
                }

                .p-serve {
                    margin-bottom:30px;
                    .p-serve-list {

                        .p-serve-con {
                            margin: 0 10px;

                            h2 {
                                font-size: 16px;
                                color: #333;
                                margin-bottom:5px;
                                span {
                                    font-size: 30px;
                                    color: #3377E7;
                                    vertical-align: -2px;
                                    display: inline-block;
                                    margin-right: 5px;
                                }
                            }

                            .p-serve-box {
                                border: 1px solid #E3E3E3;
                                border-radius: 5px;
                                margin-bottom:10px;
                                .serve-boxP {
                                    padding: 20px;
                                    height: 90px;
                                    display: flex;
                                    flex-direction: row;
                                    align-items: stretch;

                                    .pst{
                                        width:100px;
                                    }
                                    .pcont{
                                        width:220px;
                                    }
                                }
                            }

                            .p-serve-box:hover {
                                border: 1px solid #E3E3E3;
                                box-shadow: 0px 0px 20px 0px rgba(151, 151, 151, 0.5);
                            }
                        }
                    }
                }

                .p-profit{
                    margin-bottom:30px;
                    .act-tit{
                        margin-bottom:15px;
                    }
                    .p-profit-cont-list{
                        display: flex;
                        flex-flow: row;
                        align-items: center;
                        font-size:12px;
                        color:#333;
                        *{
                            padding:15px 0;
                        }
                        .pcon1{
                            width:15%;
                            text-align: center;
                            color:#999;
                        }
                        .pcon2{
                            width:17%;
                        }
                        .pcon3{
                            width: 68%;
                            padding-right:10px;
                        }
                    }
                    .p-profit-cont-list:nth-child(odd){
                        background-color: #E7EEFF;
                    }
                    .p-profit-cont-list:hover{
                        background: #fff5e6;
                    }
                }
            }
        }
    }


</style>